export const getAspectRatio = (src: string | null): Promise<[number, number, HTMLImageElement]> => {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img');
    if (typeof src === 'string') {
      img.src = src;
    }
    img.onload = () => {
      img.style.visibility = 'hidden';
      document.body.appendChild(img);
      resolve([img.clientWidth, img.clientHeight, img]);
      document.body.removeChild(img);
    };
    img.onerror = (e) => {
      reject(e);
    };
  });
};
